"use strict";
/* eslint @typescript-eslint/no-unused-expressions:"off", sonarjs/cognitive-complexity:"off" */
Object.defineProperty(exports, "__esModule", { value: true });
exports.universalOutput = exports.browserOutput = exports.nodeOutput = exports.createOutput = void 0;
var format_1 = require("../format/format");
var logger_types_1 = require("../logger/logger.types");
var createOutput = function (options) {
    var out = options.out, format = options.format;
    var log = out.log;
    var debounced = {};
    var openScopes = [];
    function print(entry, skipPrinted) {
        if (entry === null) {
            openScopes.forEach(function () {
                out.groupEnd();
            });
            openScopes.length = 0;
            return;
        }
        var parent = entry.parent;
        var opened = openScopes.length;
        if (skipPrinted && entry.printed) {
            return;
        }
        if (opened > 0) {
            var idx = opened;
            while (idx--) {
                if (openScopes[idx] === parent) {
                    break;
                }
                else {
                    openScopes[idx].printed = true;
                    out.groupEnd();
                }
            }
            openScopes.length = idx + 1;
        }
        if (entry.type === logger_types_1.SCOPE) {
            openScopes.push(entry);
            out.group.apply(out, format(entry));
            // if (entry.args && entry.args.state === 'idle') {
            // 	entry.printed = true;
            // 	log.apply(out, format(entry));
            // } else {
            // 	openScopes.push(entry);
            // 	out.group.apply(out, format(entry));
            // }
        }
        else {
            if (!skipPrinted && parent && parent.printed && parent.label !== '#root') {
                debounced[parent.cid] ||
                    (debounced[parent.cid] = setTimeout(function () {
                        openScopes.forEach(function () {
                            out.groupEnd();
                        });
                        openScopes.length = 0;
                        var chain = [];
                        var cursor = parent;
                        do {
                            chain.unshift(cursor);
                            cursor = cursor.parent;
                        } while (cursor && cursor.label !== '#root');
                        chain.forEach(function (entry) {
                            out.group.apply(out, format(entry));
                        });
                        parent.entries.forEach(function (entry) {
                            print(entry, true);
                        });
                        chain.forEach(function () {
                            out.groupEnd();
                        });
                    }, 0));
                return;
            }
            entry.printed = true;
            log.apply(out, format(entry));
        }
    }
    return print;
};
exports.createOutput = createOutput;
var nodeOutput = function (options) {
    if (options === void 0) { options = {}; }
    return (0, exports.createOutput)({
        out: options.out || console,
        format: options.format || format_1.nodeFromat,
    });
};
exports.nodeOutput = nodeOutput;
var browserOutput = function (options) {
    if (options === void 0) { options = {}; }
    return (0, exports.createOutput)({
        out: options.out || console,
        format: options.format || format_1.browserFormat,
    });
};
exports.browserOutput = browserOutput;
exports.universalOutput = typeof self === 'undefined' ? exports.nodeOutput : exports.browserOutput;
//# sourceMappingURL=output.js.map